export class ChangePassword {
  public AccountId?: string;
  public UserName?: string;
  public NewPassword?: string;
}
